import { render, staticRenderFns } from "./simplifyFeeReceipt.vue?vue&type=template&id=6adcb5ea&scoped=true"
import script from "./simplifyFeeReceipt.vue?vue&type=script&lang=js"
export * from "./simplifyFeeReceipt.vue?vue&type=script&lang=js"
import style0 from "./simplifyFeeReceipt.vue?vue&type=style&index=0&id=6adcb5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adcb5ea",
  null
  
)

export default component.exports